 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		98: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","3":"components-video_module-video_module","4":"ibdPage","6":"legacyIbdPage","8":"ad-AdContainer","9":"components-analytics-analytics","10":"components-feature_feed-feature_feed","11":"container","12":"fc_executive_board","13":"fc_link-fc_link","14":"post-content-body","15":"aboutUsWpPage","16":"author","17":"category_page","18":"components-not_found_component-not_found_component","19":"components-slug-slug","20":"customCollectionPage","21":"feed","22":"list_page","23":"list_page_2024","24":"loginPage","25":"logoutPage","26":"magazineTagPage","27":"magazine_page","28":"myAccountPage","29":"newsletters_page_marketo","30":"notFoundPage","31":"offerPage","32":"playlistIndexPage","33":"playlistPage","34":"podcastPage","35":"post_page","36":"registerPage","37":"resetPasswordPage","38":"sitemapIndex","39":"sitemapPost","40":"splash_page","41":"stories","42":"subscribePage","43":"tagPage","44":"videoIndex","45":"videoPage","46":"views-containers-layouts-blank_layout-blank_layout","47":"views-containers-layouts-web_layout-web_layout","93":"MarketoNewsletterForm","94":"MicCarousel","95":"MicIcon","96":"MicMobileIconCarousel","97":"Success-SubmissionSuccess","99":"applications-most-innovative-companies","100":"brands_that_matter_2021","101":"brands_that_matter_page","102":"categoryLink","103":"components-ApplyPageImportantDates-ApplyPageImportantDates","104":"components-BackgroundHighlight-BackgroundHighlight","105":"components-BtmCmos-index","106":"components-BtmPastHonereesLogos-index","107":"components-MultiTabList-MultiTabList","108":"components-QuickCarousel-QuickCarousel","109":"components-StickyBar-StickyBar","110":"components-all_feed-all_feed","111":"components-categories","112":"components-config-config","113":"components-editor_highlights-editor_highlights","114":"components-finite_scroll","115":"components-footer-footer","116":"components-franchise_intro-franchise_intro","117":"components-ibd_category-ibd_category","118":"components-image-image","119":"components-magazine_archive-magazine_archive","120":"components-masthead-masthead","121":"components-mcp_section-mcp_section","122":"components-mic_card-mic_card","123":"components-mic_mobile_menu-mic_mobile_menu","124":"components-more-stories-component-more-stories-component","125":"components-newsletters-recaptcha","126":"components-notice","127":"components-podcast_tile-podcast_tile","128":"components-podcast_tile-podcast_tile_featured","129":"components-post-content-insert","130":"components-ranked","131":"components-recirc-recirc","132":"components-related_posts-related_posts","133":"components-related_slider-related_slider","134":"components-sectors_list-sectors_list","135":"components-social-social","136":"components-top_50-top_50","137":"components-top_50_shuffle-top_50_shuffle","138":"components-video_megatron-video_megatron","139":"containers-pages-list_landers-bwi-2020","140":"containers-pages-list_landers-ibd-2020","141":"containers-pages-list_landers-mic-2021","142":"content-innovation_festival_banner","143":"content-sponsor_bar","144":"fc-components-main-components","145":"fc-components-main-components-StickyBar-StickyBar","146":"fc-components-main-containers","147":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","148":"fc-components-main-containers-IbdLayout-IbdLayout","149":"fc-components-main-containers-MicLayout-MicLayout","150":"fc-components-main-containers-WciLayout-WciLayout","151":"fc-components-main-utils-ConditionalWrapper","152":"franchises-BtmApplyPage","153":"franchises-BwiApplyPage","154":"franchises-IbdApplyPage","155":"franchises-MicApplyPage","156":"franchises-NbttApplyPage","157":"franchises-WciApplyPage","158":"innovation_by_design_future_page","159":"innovation_by_design_page_franchise","160":"innovation_by_design_page_franchise_2023","161":"layouts","162":"layouts-mcp","163":"nav_main_menu-nav_main_menu","164":"package_article_list_entry","165":"packages-nav-package_sticky_nav","166":"post-content-sidebar","167":"topics"}[chunkId]||chunkId) + "." + {"1":"d9246c332dbb893008c9","2":"4f8bed5e1626e8852ba2","3":"f1f43f9e2dcff8d6d396","4":"a52a08bfc5dd05c97293","5":"6df3297daa894e5266bd","6":"a0dd9121249fdd47ac5d","7":"2b885c9eea8de02c4142","8":"db98f07af373c010b176","9":"9e72471b2ddb48b830ed","10":"43df4ef53b5d4b0b30b6","11":"62b8fff16055c65b0e5f","12":"dc7d4b227a82fb00547a","13":"608e47a091aea1d16214","14":"5462c0fc8844232c723d","15":"7879d88106b25159d54b","16":"1718df19a257aa586332","17":"9a9855394f190837b974","18":"aef52050efc33753bf74","19":"f52a27c59af1a4dc50b4","20":"e86f8eede3bf5cc876b9","21":"2b33b199d441716749ca","22":"c3cd7ff7718477d78218","23":"c244bec9fb1717d1af4d","24":"8a013ccd3704bda516ff","25":"9f7c6c7ea85ff044bd63","26":"cc467ade01c05438eb85","27":"b91980c52c4736596975","28":"b68bcae6fb5eccc0c4b7","29":"286e03b16f808aabc58b","30":"7cad14054000ad469787","31":"7f283b7ebda11370c2bb","32":"ae460b658bca4abc0e31","33":"b09d93b8f9705b65c92c","34":"d98d03bf01e526254a01","35":"f560a6ab211deb0e9320","36":"03c416b30343a9ba17e1","37":"b609a923f97abb55cb41","38":"0d9b4ccabe37e85ec9e0","39":"96057a08b837d4260974","40":"3b3c021349365beff870","41":"da04d16e6ce5c79c88fe","42":"b40354832e8c44ee6173","43":"236e8962c811372adb0b","44":"ea6424811b0a8114db5f","45":"8b78d36786c597f3923b","46":"a67f9e7b43065d27523c","47":"f4d04c68d499b3d6f18a","48":"82c23e8b6bafafe815fb","49":"9c537f63369a04199376","50":"02f4f46ad1fd2096daa6","51":"748a416e2d884ed2da63","52":"bd063fdc069dc3f6dea6","53":"1725e45c4816ac22c63b","54":"39acc835323851a469a2","55":"89439674d7fa6d131b80","56":"1f0fda1efc36b8dc222e","57":"cd20fc93a81b5a053e55","58":"b387eeb88bf6db798724","59":"6910932abe5971c98878","60":"b9734c7961d0e5165596","61":"a167618b75b0df376c2a","62":"1e47803ad42371cf7949","63":"fb7d7096aeec64a8dc81","64":"7d802c7431165d6fefd9","65":"363f1e0b1049f00ae457","66":"4e58fdb6be7b19cf3cad","67":"8388c7dee9df3cfc1d42","68":"29655d48c37c10e39d1b","69":"0e3ec74150bd0c736fa6","70":"3cca713486e97006b21a","71":"f681eac9880cae9ab06b","72":"4f7c9276427bf12efa1f","73":"ff898aeb499210ba5895","74":"9f9c7f9fa7851e76efe7","75":"751a6ccb69357587d598","76":"93e1671eb68e2d1bcc39","77":"10b1db08df1bcc17e7e1","78":"9a9d2172bcdcdc8cf08b","79":"a18af686878b599becbc","80":"1745d8b9036a163f7f3f","81":"61f50e4b58067426dc14","82":"d64a9fa39e70d79f0fd9","83":"217f582de34b84069da9","84":"bb4f66d8448b2678602f","85":"631f95e3d2f744b9d486","86":"ea23bdffef039b8d7e7f","87":"b5ddc9d4e17830ea59ab","88":"515ee8852108a4b88159","89":"e499d9429a7293256171","90":"532dc9e28b7e6633c4cf","91":"ad345df6b95c5b2ac71b","92":"b677977806375411384b","93":"60e7941d0f9ef5ca31ea","94":"f4ecc23e4383d896d6d7","95":"b248190a05b17574b23c","96":"2c02759deddef50de723","97":"ec6e0e0dec8ab49cb462","99":"873897d18970dc2c4289","100":"f32eebd76983962c6bfe","101":"dbd83e701fe9d3bf2bae","102":"435d80ce28c1569c4528","103":"019db9750a0f6262471e","104":"82f99224ee7cca4b39e6","105":"2d1eee3f9d29ca516c41","106":"7c90a04e2caf45708306","107":"e6e3e5b41444cf2174af","108":"082f20453a4b0deade75","109":"6b54011b88a09e3f4bed","110":"0b23fe8a84ebb00c7c59","111":"ec6db6f07eeb3cb0e003","112":"8a5d0ba0d9bd02b1a0db","113":"f33fe042e2e9ab3d5605","114":"005034d8bb610109998f","115":"1f5940776d431b0ca0d8","116":"98b586bedebf782f800c","117":"1264397f684467735bc3","118":"cf725e2ab2ff548912c5","119":"2e335d3c6cb940c9922f","120":"d929da4a3de363689a80","121":"c57b639ee43e2ad3321c","122":"3186ae97c5ccea456f40","123":"6ceed2a7ca2cf9b3c1b5","124":"b5483b7fb8747304f0b2","125":"9327ecd89c081a4ae8c9","126":"b8a80ddbbbaaae33f841","127":"fb024a2ab1aa07bd12f6","128":"9f9b9aa13eea38b63e4c","129":"812fb61d79a05f0e40d5","130":"14c14c17aa3f3cd8dfe9","131":"b14b32bf26e5fd0430e8","132":"8568bbc0658bbaf5479c","133":"e95366ca9a727d2d71f7","134":"4b8cd3c2974f115a45af","135":"0a4fba19a7c1135b32a7","136":"1db14d3cf3f254947f9f","137":"84ad988b350bc0bb273b","138":"4baf16a0649fa0128686","139":"ee6b28f7a28038f40abd","140":"491012c0ab1f9fda487b","141":"e19b4a6853f77c2d672b","142":"901c3db531066d5b81ca","143":"a1176334ceedf0f8fe8e","144":"f3eca6b7a4145425c00a","145":"9fd800249c66771a8e52","146":"9d747626cb291238e259","147":"9af8307ab4a29b9b7174","148":"98b28f42ffd36c5e9b46","149":"5dd8d53369e858f21c4a","150":"81e0875c485af1fff48d","151":"ea9b2d68a0d7e560e8d4","152":"ff72ce692f7542c9fe43","153":"61b4a358f5099bd6a494","154":"19a97d9ed9a605306f8e","155":"45a5c1107bdc7c3c8fb6","156":"7646eeafc85a9c366e24","157":"010d29961282d6c6503e","158":"ec52031ad7fa0564c96b","159":"f74857dec218f036099d","160":"94a7c82e5e0eec4d96fa","161":"1b47583f8acf6903b4c7","162":"31f811b65b0d0fc6fde2","163":"9f1c571eabd12de3f89b","164":"21794102760407d62fcb","165":"3b8c3936a59ae438f017","166":"08ab021e8a0ea4c5233f","167":"729a2c8acd87aac566ea"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([762,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
